/*
* Report page
*/

import * as _ from 'lodash';
import * as React from 'react';
import { Row } from 'react-bootstrap';

import { BootstrapColXl as Col } from '../../../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../../../common/formatters';
import * as PropertyReportComponents from '../report-components';

export const Render = ({ reportData, appText, appTextCommon, ...rest }) => {
    const { association, associationId, ...otherReportData } = reportData;
    const assocLocation = _.get(association, 'location', {});
    const assocContact = _.get(association, 'contact', {});
    const assocDetails = _.get(association, 'details', {});

    const assocClient = _.get(association, 'client', {});
    const assocClientLocation = _.get(assocClient, 'location', {});

    const commonAmenitiesProps = {
        titleColXs: 6,
        childrenColXs: 6
    };

    const RenderLocationItems = ({ locationObj, ...otherLocationProps }) => {
        return (
            <div className="render-location-items-container">
                <PropertyReportComponents.PropertyReportItem title={appTextCommon('location.address')}>
                    {Formatters.getStr(locationObj, 'address1')}
                </PropertyReportComponents.PropertyReportItem>
                <PropertyReportComponents.PropertyReportItem title={appTextCommon('location.city')}>
                    {Formatters.getStr(locationObj, 'city')}
                </PropertyReportComponents.PropertyReportItem>
                <PropertyReportComponents.PropertyReportItem title={appTextCommon('location.state')}>
                    {Formatters.getStr(locationObj, 'stateCode')}
                </PropertyReportComponents.PropertyReportItem>
                <PropertyReportComponents.PropertyReportItem title={appTextCommon('location.zip')}>
                    {Formatters.getStr(locationObj, 'postalCode')}
                </PropertyReportComponents.PropertyReportItem>
            </div>
        );
    };

    return (
        <div className="render-propterty-report-page-cover-class">
            <PropertyReportComponents.PropertyReportPage className="pdf-association-property-report-cover-page" reportData={reportData}>
                <PropertyReportComponents.PropertyReportItem
                    title={associationId}
                    titleClassName="pdf-association-property-report-item-title-header"
                    childrenWrapperClassName="pdf-association-property-report-item-title-header"
                >
                    {Formatters.getStr(association, 'name')}
                </PropertyReportComponents.PropertyReportItem>

                <PropertyReportComponents.PropertyLocationItems
                    locationObj={assocLocation}
                    appTextCommon={(s) => appTextCommon(s)}
                />
                <PropertyReportComponents.PropertyReportItem title={appText('fiscal-year-end')}>
                    {Formatters.getStr(assocDetails, 'fiscalYearEnd')}
                </PropertyReportComponents.PropertyReportItem>

                <PropertyReportComponents.PropertyReportItemSpacer />

                <PropertyReportComponents.PropertyReportItem title={appTextCommon('name')}>
                    {Formatters.composeClientContactLetter(assocContact, true)}
                </PropertyReportComponents.PropertyReportItem>
                <PropertyReportComponents.PropertyReportItem title={appText('client-id')}>
                    {Formatters.getInt(assocClient, 'clientId')}
                </PropertyReportComponents.PropertyReportItem>
                <PropertyReportComponents.PropertyReportItem title={appText('client')}>
                    {Formatters.getStr(assocClient, 'name')}
                </PropertyReportComponents.PropertyReportItem>
                <PropertyReportComponents.PropertyReportItem title={appText('phone')}>
                    {Formatters.formatPhoneNumber(Formatters.getStr(assocClient, 'phone'))}
                </PropertyReportComponents.PropertyReportItem>

                <PropertyReportComponents.PropertyReportItemSpacer />

                <RenderLocationItems locationObj={assocClientLocation} />
                <PropertyReportComponents.PropertyReportItem title={appText('fiscal-year-end')}>
                    {Formatters.getStr(assocDetails, 'fiscalYearEnd')}
                </PropertyReportComponents.PropertyReportItem>

                <Row>
                    <Col xs={12} className="text-center pdf-association-property-report-header-property-description">
                        {appText('property-description')}
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} className="pdf-association-property-report-header-section">
                        {appText('construction-information')}
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} className="pdf-association-property-report-item-title">
                        <PropertyReportComponents.PropertyReportTableItem title={appText('num-units')} value={String(Formatters.getInt(assocDetails, 'numberUnits'))} />

                        <PropertyReportComponents.PropertyReportTableItem title={appText('num-buildings')} value={String(Formatters.getInt(assocDetails, 'numberBuildings'))} />

                        <PropertyReportComponents.PropertyReportTableItem title={appText('construction-date')} value={Formatters.getStr(assocDetails, 'constructDate')} colTitleClassName="col-width-55" />
                    </Col>
                </Row>

                <PropertyReportComponents.PropertyReportItemSpacer colClassName="pdf-association-property-report-item-spacer-thin" />

                <Row>
                    <Col xs={12} className="pdf-association-property-report-item-title">
                        <PropertyReportComponents.PropertyReportTableItem title={appText('num-phases')} value={Formatters.getStr(assocDetails, 'phases')} />

                        <PropertyReportComponents.PropertyReportTableItem title={appText('num-stories')} value={String(Formatters.getInt(assocDetails, 'numberStories'))} />

                        <PropertyReportComponents.PropertyReportTableItem title={appText('conversion-date')} value={Formatters.getStr(assocDetails, 'converDate')} colTitleClassName="col-width-55" />
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} className="pdf-association-property-report-header-section">
                        {appText('property-type')}
                    </Col>
                </Row>

                <PropertyReportComponents.PropertyReportItem title={appText('property-type')} titleColXs={3} childrenColXs={9}>
                    {Formatters.getStr(association, 'associationType.name')}
                </PropertyReportComponents.PropertyReportItem>

                <Row>
                    <Col xs={12} className="pdf-association-property-report-header-section">
                        {appText('common-area-amenities')}
                    </Col>
                </Row>

                <Row>
                    <Col xs={6}>
                        <PropertyReportComponents.PropertyReportItem title={appText('streets')} {...commonAmenitiesProps}>
                            {Formatters.getStr(assocDetails, 'streets')}
                        </PropertyReportComponents.PropertyReportItem>
                        <PropertyReportComponents.PropertyReportItem title={appText('siding')} {...commonAmenitiesProps}>
                            {Formatters.getStr(assocDetails, 'siding')}
                        </PropertyReportComponents.PropertyReportItem>
                        <PropertyReportComponents.PropertyReportItem title={appText('roofs')} {...commonAmenitiesProps}>
                            {Formatters.getStr(assocDetails, 'roofs')}
                        </PropertyReportComponents.PropertyReportItem>
                        <PropertyReportComponents.PropertyReportItem title={appText('fencing')} {...commonAmenitiesProps}>
                            {Formatters.getStr(assocDetails, 'fencing')}
                        </PropertyReportComponents.PropertyReportItem>
                        <PropertyReportComponents.PropertyReportItem title={appText('interior-hallways')} {...commonAmenitiesProps}>
                            {Formatters.getStr(assocDetails, 'interiorHalls')}
                        </PropertyReportComponents.PropertyReportItem>
                        <PropertyReportComponents.PropertyReportItem title={appText('irrigation')} {...commonAmenitiesProps}>
                            {Formatters.getStr(assocDetails, 'irrigation')}
                        </PropertyReportComponents.PropertyReportItem>
                        <PropertyReportComponents.PropertyReportItem title={appText('secured-property')} {...commonAmenitiesProps}>
                            {Formatters.getStr(assocDetails, 'secured')}
                        </PropertyReportComponents.PropertyReportItem>
                    </Col>
                    <Col xs={6}>
                        <PropertyReportComponents.PropertyReportItem title={appText('mechanical')} {...commonAmenitiesProps}>
                            {Formatters.getStr(assocDetails, 'mechanical')}
                        </PropertyReportComponents.PropertyReportItem>
                        <PropertyReportComponents.PropertyReportItem title={appText('elevators')} {...commonAmenitiesProps}>
                            {Formatters.getStr(assocDetails, 'elevators')}
                        </PropertyReportComponents.PropertyReportItem>
                        <PropertyReportComponents.PropertyReportItem title={appText('pools')} {...commonAmenitiesProps}>
                            {Formatters.getInt(assocDetails, 'pools')}
                        </PropertyReportComponents.PropertyReportItem>
                        <PropertyReportComponents.PropertyReportItem title={appText('spas')} {...commonAmenitiesProps}>
                            {Formatters.getInt(assocDetails, 'spas')}
                        </PropertyReportComponents.PropertyReportItem>
                        <PropertyReportComponents.PropertyReportItem title={appText('tennis-courts')} {...commonAmenitiesProps}>
                            {Formatters.getInt(assocDetails, 'tennis')}
                        </PropertyReportComponents.PropertyReportItem>
                        <PropertyReportComponents.PropertyReportItem title={appText('clubhouse-rec-room')} {...commonAmenitiesProps}>
                            {Formatters.getStr(assocDetails, 'recRooms')}
                        </PropertyReportComponents.PropertyReportItem>
                    </Col>
                </Row>

                <PropertyReportComponents.PropertyReportItemSpacer colClassName="pdf-association-property-report-item-spacer-thin" />

                <PropertyReportComponents.PropertyReportItem title={appText('notes')}>
                    {Formatters.getStr(association, 'notes[0].notes')}
                </PropertyReportComponents.PropertyReportItem>

            </PropertyReportComponents.PropertyReportPage>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/association/property-report/pages/report-page-cover.tsx